 export const imageSlider = [
    {
        id:1,
        img:"https://rukminim1.flixcart.com/image/200/200/l0e6kcw0/t-shirt/h/g/d/m-half-triangel-black-one-nb-nicky-boy-original-imagc747apzffz5q.jpeg?q=70"
    },
    {
        id:2,
        img:"https://rukminim1.flixcart.com/image/200/200/xif0q/t-shirt/x/j/5/xs-bwtrnful-z55-blive-original-imaggvyuc8emdn9g.jpeg?q=70"
    },
    {
        id:3,
        img:"https://rukminim1.flixcart.com/image/312/312/l1fc0i80/t-shirt/4/l/i/s-b002-stylogue-original-imagczqugpqwvvf5.jpeg?q=70"
    },
    {
        id:4,
        img:"https://rukminim1.flixcart.com/image/312/312/kri3xjk0/t-shirt/k/e/h/m-qw23ws-thefashionplus-original-imag59v5hyntsph6.jpeg?q=70"
    },

  
]

export const allMenProducts =[
    {
        id:1,
        name:'KILLER',
        price:400,
        img:"https://rukminim1.flixcart.com/image/660/792/kg8avm80/track-pant/n/g/f/m-kj-lp-f502-r-l-brw-killer-original-imafwhvbzpsnmgae.jpeg?q=50"
    },
    {
        id:2,
        name:'HIGHLANDER',
        price:299,
        img:"https://rukminim1.flixcart.com/image/660/792/xif0q/track-pant/k/j/l/36-hlz4000091-highlander-original-imagf3y7nrucbgyy-bb.jpeg?q=50"
    },
    {
        id:3,
        name:'HIGHLANDER',
        price:522,
        img:'https://rukminim1.flixcart.com/image/660/792/km2clu80/shirt/f/l/f/s-hlsh012508-highlander-original-imagffwunskheva7.jpeg?q=50'
    },
    {
        id:4,
        name:'ADIDAS',
        price:899,
        img:'https://rukminim1.flixcart.com/image/660/792/xif0q/jean/g/z/p/32-eckn-01bb-041-spykar-original-imagh6zjt36uvzgy.jpeg?q=50'
    },
    {
        id:5,
        name:'ADIDAS',
        price:699,
        img:'https://rukminim1.flixcart.com/image/660/792/xif0q/t-shirt/w/v/p/m-hr3226-adidas-original-imaghs5kabhpthsb.jpeg?q=50'
    },
    {
        id:6,
        name:'TRIPR',
        price:599,
        img:'https://rukminim1.flixcart.com/image/660/792/l2tcfbk0/shirt/w/n/x/s-hlsh013646-highlander-original-image2prxyuskyv8.jpeg?q=50'
    },
    {
        id:7,
        name:'ADIDAS',
        price:799,
        img:'https://rukminim1.flixcart.com/image/660/792/xif0q/track-pant/y/u/z/m-gt5567-adidas-original-imag6hwssfmhycsg-bb.jpeg?q=50'
    },
    {
        id:8,
        name:'SMARTEES',
        price:1080,
        img:'https://rukminim1.flixcart.com/image/660/792/xif0q/jean/9/3/s/32-9481-slm-slmft-mding-killer-original-imaggmr7yxt98ha6.jpeg?q=50'
    },
    {
        id:9,
        name:'PUMA',
        price:1199,
        img:'https://rukminim1.flixcart.com/image/660/792/l4pxk7k0/t-shirt/x/s/f/-original-imagfkfmsq5aax2h.jpeg?q=50'
    },
    {
        id:10,
        name:'PUMA',
        price:1499,
        img:'https://rukminim1.flixcart.com/image/660/792/ktd9mkw0/t-shirt/6/d/q/m-67029605-puma-original-imag6q3amzf2kezh.jpeg?q=50'
    }
]
export const allMenCategories =[
    {
        id:1,
        cat: "T-shirt"
    },
    {
        id:2,
        cat: "Shirt"
    },
    {
        id:3,
        cat: "Jeans"
    },
    {
        id:4,
        cat: "Trouser"
    },
]

export const allWomenProducts = [
    {
        id:1,
        name:"ishika fab",
        price:849,
        img:'https://rukminim1.flixcart.com/image/566/679/l1b1oy80/sari/b/x/e/free-blackberry-5-ishika-fab-unstitched-original-imagcwaxtf4dqzv8.jpeg?q=50'
    },
    {
        id:2,
        name:"Samah",
        price:309,
        img:'https://rukminim1.flixcart.com/image/566/679/kjkbv680-0/kurta/b/5/w/xl-322k772-saara-original-imafz3xfdnekz6by.jpeg?q=50'
    },
    {
        id:3,
        name:"Kriska",
        price:359,
        img:'https://rukminim1.flixcart.com/image/566/679/xif0q/kurta/6/i/g/s-kr-06-wine-kriska-original-imafxqutadagxnqh-bb.jpeg?q=50'
    },
    {
        id:4,
        name:"ZaaHii",
        price:450,
        img:'https://rukminim1.flixcart.com/image/566/679/l4bn5ow0/jean/u/i/c/28-jeans-01-zh-zaahii-original-imagf94ea2jrug8f.jpeg?q=50'
    },
    {
        id:5,
        name:"Gujari",
        price:471,
        img:'https://rukminim1.flixcart.com/image/566/679/xif0q/kurta/u/5/s/s-kurti-503-gujari-original-imag883udw6c7xxq-bb.jpeg?q=50'
    },
    {
        id:6,
        name:"Paragon",
        price:242,
        img:'https://rukminim1.flixcart.com/image/566/679/xif0q/sandal/t/q/7/-original-imaghxfg8khdgsyv.jpeg?q=50'
    },
    {
        id:7,
        name:"Paduki",
        price:284,
        img:'https://rukminim1.flixcart.com/image/566/679/l5h2xe80/sandal/y/8/p/-original-imagg58fpacvuurg.jpeg?q=50'
    },
    {
        id:8,
        name:"Vishudh",
        price:464,
        img:'https://rukminim1.flixcart.com/image/566/679/kjabs7k0-0/dress/t/v/l/l-vna1001019-vishudh-original-imafyvv25chzs4qx.jpeg?q=50'
    },
    {
        id:9,
        name:"MAA FAB",
        price:199,
        img:'https://rukminim1.flixcart.com/image/566/679/kflftzk0/dress/n/c/d/l-one-piece-orrange-line-maa-fab-original-imafwyy3esacjzau.jpeg?q=50'
    },
    {
        id:10,
        name:"KOTTY",
        price:100,
        img:'https://rukminim1.flixcart.com/image/566/679/keaaavk0-0/jean/p/g/u/34-kttladiesjeans670-kotty-original-imafuzrrgcfg9sds.jpeg?q=50'
    }
]
export const allWomenCategories =[
    {
        id:1,
        cat: "Kurti"
    },
    {
        id:2,
        cat: "Saree"
    },
    {
        id:3,
        cat: "Jeans"
    },
    {
        id:4,
        cat: "Sandals"
    },
]

export const allMobiles = [
    {
        id:1,
        name:'realme C30s (Stripe Black, 32 GB)',
        price:7499,
        img:'https://rukminim1.flixcart.com/image/312/312/xif0q/mobile/f/g/j/-original-imagg3myshvfpzjb.jpeg?q=70'
    },
    {
        id:2,
        name:'SAMSUNG Galaxy F13 (Nightsky Green, 64 GB)',
        price:9499,
        img:'https://rukminim1.flixcart.com/image/312/312/l4n2oi80/mobile/m/w/x/-original-imagfhu6bdzhnmkz.jpeg?q=70'
    },
    {
        id:3,
        name:'POCO C31 (Royal Blue, 64 GB)',
        price:7777,
        img:'https://rukminim1.flixcart.com/image/312/312/ku4ezrk0/mobile/p/e/4/c31-mzb0a0jin-poco-original-imag7bzqxgdhgf2n.jpeg?q=70'
    },
    {
        id:4,
        name:'IAIR D25  (Green)',
        price:1209,
        img:'https://rukminim1.flixcart.com/image/312/312/l3uhvgw0/mobile/p/c/d/2g-dual-sim-1-7-inch-display-32-mb-storage-0-8-mp-camera-d25-original-imageveupes9wbyh.jpeg?q=70'
    },
    {
        id:5,
        name:'REDMI 10 (Midnight Black, 64GB)',
        price:8999,
        img:'https://rukminim1.flixcart.com/image/312/312/l0tweq80/mobile/x/f/u/-original-imagcgtghym8theg.jpeg?q=70'
    },
]

export const allMobilesCategories =[
    {
        id:1,
        cat: "Realme"
    },
    {
        id:2,
        cat: "Samsung"
    },
    {
        id:3,
        cat: "Poco"
    },
    {
        id:4,
        cat: "Redmi"
    },
    {
        id:5,
        cat: "Iair D25"
    },
]

export const allGames =[
    {
        id:1,
        name:'Grand Theft Auto V ROCKSTAR Download code only (No CD/DVD) ',
        price:899,
        img:'https://rukminim1.flixcart.com/image/612/612/l3ahpjk0/code-in-the-box-game/m/8/b/pc-grand-theft-auto-v-rockstar-download-code-only-no-cd-dvd-original-imagegf3wgysgg2z.jpeg?q=70'

    },
    {
        id:2,
        name:'PS4 God Of War Ragnarok Launch Edition (PS4) (Launch Edition)',
        price:3999,
        img:'https://rukminim1.flixcart.com/image/416/416/l5jxt3k0/physical-game/b/a/f/-original-imagg7gmqnpt5dtd.jpeg?q=70'

    },
    {
        id:3,
        name:'Minecraft  (Code in the Box - for Xbox One)',
        price:649,
        img:'https://rukminim1.flixcart.com/image/416/416/kar44280/code-in-the-box-game/q/z/8/xbox-one-minecraft-standard-edition-original-imafs9bbgesjfx8s.jpeg?q=70'

    },
    {
        id:4,
        name:'PS5 Cricket 22 International Edition (International Edition)  (for PS5)',
        price:2299,
        img:'https://rukminim1.flixcart.com/image/612/612/kulk9zk0/physical-game/n/y/b/no-international-edition-ps5-cricket-22-international-edition-original-imag7zngwuz8m3j5.jpeg?q=70'

    },
    {
        id:5,
        name:'Call of Duty Modern Warfare 1-2-3 Top Three Game Combo (Offline Only) (Regular)  (Action Adventure, for PC)',
        price:745,
        img:'https://rukminim1.flixcart.com/image/416/416/kklhbbk0/physical-game/y/w/r/regular-vgpcys-call-of-duty-modern-warfare-1-2-3-total-3-game-original-imafzwpyzg7mj2zb.jpeg?q=70'

    },
]

export const allGamesCategories =[
    {
        id:1,
        cat: "PC"
        
    },
    {
        id:2,
        cat: "PS4"
    },
    {
        id:3,
        cat: "XBOX"
    },
    {
        id:4,
        cat: "PS5"
    },
    
]